<script setup>
  import { onUnmounted } from 'vue';
  import PL_ContactRequestModal from './pl/ContactRequestModal.vue';
  import DE_ContactRequestModal from './de/ContactRequestModal.vue';
  import CH_ContactRequestModal from './ch/ContactRequestModal.vue';
  import JP_ContactRequestModal from './jp/ContactRequestModal.vue';
  import { useMainStore } from '../../store/index';

  const store = useMainStore();

  const componentMapping = {
    'pl': PL_ContactRequestModal,
    'de': DE_ContactRequestModal,
    'ch': CH_ContactRequestModal,
    'jp': JP_ContactRequestModal,
  };

  onUnmounted(() => {
    store.contactRequested = false;
  });
</script>

<template>
  <component :is="componentMapping[store.market]" />
</template>

<style scoped>
</style>
